export enum InvoiceStatus {
    Unpaid = 0,
    PartiallyPaid = 1,
    Paid = 2,
    Cancelled = 3,
}